import get from 'lodash/get';
import moment from 'moment';

import { createServiceAction } from '../util/actionHelper.js';
import {
  displaySubmitButtonQrf, displayClearButtonQrf, clearFormValueQRF, attachmentQrf, updateGuideYes, updateGuideNo,
  updateFutureProductYes, updateDisgardTrf, updateProposedCorrectiveAction
} from '../actions/qrfActions.js';
import { convertDateToDBFormat } from '../util/index.js'

const defaultState = {
  errorClassName: [false, true, true],
  qrfData: {},
  attachment: [],
  attachmentNew: [],
  guideYes: false,
  guideNo: false
};
let futureProductYes = false;
let disgardTrf = false;
let qrfArray = {
  affectedMaterial: '',
  materialAffectedQty: '',
  materialWorth: '',
  affectedMaterialLeft: '',
  futureProduction: null,
  isError: true,
  affectedMaterialForKid: false,
  immediateStep: '',
  factoryList: '',
};
let frfArray = {
  failureDesc: '',
  dateOfCompletion: '',
  correctiveAction: '',
  rootCause: '',
  PDCA: '',
  isUploaded: '',
  isError: true,
  proposedCorrectiveAction: ''
};

const reviewFlag = {
  isError: true
};
function oldQrfFormValidation(formDetails){
  if (formDetails.meta.field==='affectedMaterial') {
    qrfArray.affectedMaterial = formDetails.payload;
  }
  if (formDetails.meta.field.indexOf('materialAffectedQty') !== -1) {
    qrfArray.materialAffectedQty = formDetails.payload;
  }
  if (formDetails.meta.field.indexOf('materialWorth') !== -1) {
    qrfArray.materialWorth = formDetails.payload;
  }
  if (formDetails.meta.field.indexOf('affectedMaterialLeft') !== -1) {
    qrfArray.affectedMaterialLeft = true;
  }
  if (formDetails.meta.field.indexOf('factoryList') !== -1) {
    qrfArray.factoryList = formDetails.payload;
  }
  if (formDetails.meta.field.indexOf('immediateStep') !== -1) {
    qrfArray.immediateStep = formDetails.payload;
  }
  if (formDetails.meta.field.indexOf('affectedMaterialForKid') !== -1) {
    qrfArray.affectedMaterialForKid = true;
  }


  if (
    qrfArray.affectedMaterial !== '' &&
    qrfArray.materialAffectedQty !== '' &&
    qrfArray.materialWorth !== '' &&
    qrfArray.factoryList !== '' &&
    qrfArray.immediateStep !== '' &&
    qrfArray.affectedMaterialLeft &&
    qrfArray.affectedMaterialForKid
  ) {
    qrfArray.isError = false;
  } else {
    qrfArray.isError = true;
  }
  if (!qrfArray.isError) {
    reviewFlag.isError = false;
  } else {
    reviewFlag.isError = true;
  }
  return [false, qrfArray.isError, reviewFlag.isError];
}


function isValidated(formDetails) {
  if (formDetails.meta.form === 'Remediation') {
    if (formDetails.meta.field === 'affectedMaterial') {
      qrfArray.affectedMaterial = formDetails.payload;
    }
    if (formDetails.meta.field.indexOf('materialAffectedQty') !== -1) {
      qrfArray.materialAffectedQty = formDetails.payload;
    }
    if (formDetails.meta.field.indexOf('materialWorth') !== -1) {
      qrfArray.materialWorth = formDetails.payload;
    }
    if (formDetails.meta.field.indexOf('affectedMaterialLeft') !== -1) {
      qrfArray.affectedMaterialLeft = formDetails.payload;
    }
    if (formDetails.meta.field.indexOf('futureProduction') !== -1) {
      qrfArray.futureProduction = formDetails.payload;
    }
    if (formDetails.meta.field.indexOf('failureDesc') !== -1) {
      frfArray.failureDesc = formDetails.payload;
    }
    if (formDetails.meta.field.indexOf('dateOfCompletion') !== -1) {
      frfArray.dateOfCompletion = convertDateToDBFormat(formDetails.payload);
      //date picker component default value is changed to empty string.
      frfArray.dateOfCompletion = (frfArray.dateOfCompletion === '1970-01-01' ? '' : frfArray.dateOfCompletion);

    }
    if (formDetails.meta.field.indexOf('correctiveAction') !== -1) {
      frfArray.correctiveAction = formDetails.payload;
    }
    if (formDetails.meta.field.indexOf('rootCause') !== -1) {
      frfArray.rootCause = formDetails.payload;
    }
    if (formDetails.meta.field.indexOf('PDCA') !== -1) {
      frfArray.PDCA = formDetails.payload;
    }
    if(formDetails.meta.field.indexOf('disgardTrf') !== -1){
      disgardTrf = formDetails.payload;
    }
    if(formDetails.meta.field.indexOf('futureProductYes') !== -1){
      futureProductYes = formDetails.payload;
    }
    if(formDetails.meta.field.indexOf('proposedCorrectiveAction') !== -1){
      frfArray.proposedCorrectiveAction = formDetails.payload;
    }
    if( qrfArray.affectedMaterialLeft !== '' &&
      qrfArray.materialAffectedQty !== '' &&
      qrfArray.materialWorth !== '' &&
      qrfArray.futureProduction === 'No' && disgardTrf === true){
        qrfArray.isError = false;
    }
    else if( qrfArray.affectedMaterialLeft !== '' &&
      qrfArray.materialAffectedQty !== '' &&
      qrfArray.materialWorth !== '' &&
      qrfArray.futureProduction !== '' && frfArray.PDCA === "No"){
        qrfArray.isError = true;
    }
    
    else if (
      qrfArray.materialAffectedQty !== '' &&
      qrfArray.materialWorth !== '' &&
     // qrfArray.futureProduction !== '' &&
      qrfArray.affectedMaterialLeft !== '' &&
      (frfArray.failureDesc !== '' && frfArray.failureDesc !== null) &&
     // frfArray.dateOfCompletion !== '' &&
      (frfArray.rootCause !== '' && frfArray.rootCause !== null) &&
      (frfArray.correctiveAction !== '' && frfArray.correctiveAction !== null) &&
      //frfArray.PDCA !== '' &&
      frfArray.proposedCorrectiveAction !== '' &&
      ((qrfArray.futureProduction === 'Yes' && futureProductYes)||
      (qrfArray.futureProduction === 'No' && disgardTrf)) &&
      frfArray.PDCA === 'Yes'
    ) {
      qrfArray.isError = false;
    } else {
      qrfArray.isError = true;
    }
    if (!qrfArray.isError) {
      reviewFlag.isError = false;
    } else {
      reviewFlag.isError = true;
    }
    return [false, qrfArray.isError, reviewFlag.isError];
  }
  if( formDetails.meta.form === 'QrfInfo'){
    return oldQrfFormValidation(formDetails)
  }
}
function oldQrFormValidate(formDetails){
  if (formDetails.meta.form === 'QrfInfo') {
    if (formDetails.payload.affectedMaterial) {
      qrfArray.affectedMaterial = formDetails.payload.affectedMaterial;
    }
    if (formDetails.payload.materialAffectedQty) {
      qrfArray.materialAffectedQty = formDetails.payload.materialAffectedQty;
    }
    if (formDetails.payload.materialWorth) {
      qrfArray.materialWorth = formDetails.payload.materialWorth;
    }
    if (formDetails.payload.affectedMaterialLeft) {
      qrfArray.affectedMaterialLeft = true;
    }
    if (formDetails.payload.factoryList) {
      qrfArray.factoryList = formDetails.payload.factoryList;
    }
    if (formDetails.payload.immediateStep) {
      qrfArray.immediateStep = formDetails.payload.immediateStep;
    }
    if (formDetails.payload.affectedMaterialForKid) {
      qrfArray.affectedMaterialForKid = true;
    }

    if (
      qrfArray.affectedMaterial !== '' &&
      qrfArray.materialAffectedQty !== '' &&
      qrfArray.materialWorth !== '' &&
      qrfArray.factoryList !== '' &&
      qrfArray.immediateStep !== '' &&
      qrfArray.affectedMaterialLeft &&
      qrfArray.affectedMaterialForKid
    ) {
      qrfArray.isError = false;
    } else {
      qrfArray.isError = true;
    }
    if (!qrfArray.isError) {
      reviewFlag.isError = false;
    } else {
      reviewFlag.isError = true;
    }
  }
  return [false, qrfArray.isError, reviewFlag.isError];
}

function validate(formDetails) {
  if (formDetails.meta.form === 'Remediation') {
    if (formDetails.payload.affectedMaterial) {
      qrfArray.affectedMaterial = formDetails.payload.affectedMaterial;
    }
    if (formDetails.payload.materialAffectedQty) {
      qrfArray.materialAffectedQty = formDetails.payload.materialAffectedQty;
    }
    if (formDetails.payload.materialWorth) {
      qrfArray.materialWorth = formDetails.payload.materialWorth;
    }
    if (formDetails.payload.affectedMaterialLeft) {
      qrfArray.affectedMaterialLeft = formDetails.payload.affectedMaterialLeft;
    }
    if (formDetails.payload.futureProduction) {
      qrfArray.futureProduction = formDetails.payload.futureProduction;
    }
   if (formDetails.payload.failureDesc) {
      frfArray.failureDesc = formDetails.payload.failureDesc;
    }
    if (formDetails.payload.dateOfCompletion) {
      frfArray.dateOfCompletion = convertDateToDBFormat(formDetails.payload.dateOfCompletion);
  
    }
    if (formDetails.payload.correctiveAction) {
      frfArray.correctiveAction = formDetails.payload.correctiveAction;
    }
    if (formDetails.payload.rootCause) {
      frfArray.rootCause = formDetails.payload.rootCause;
    }
    if (formDetails.payload.PDCA) {
      frfArray.PDCA = formDetails.payload.PDCA;
    }
    if(formDetails.payload.disgardTrf){
      disgardTrf = formDetails.payload.disgardTrf;
    }
    if(formDetails.payload.futureProductYes){
      futureProductYes = formDetails.payload.futureProductYes;
    }
    if(formDetails.payload.proposedCorrectiveAction) {
      frfArray.proposedCorrectiveAction = formDetails.payload.proposedCorrectiveAction;
    }
    if( qrfArray.affectedMaterialLeft !== '' &&
      qrfArray.materialAffectedQty !== '' &&
      qrfArray.materialWorth !== '' &&
      qrfArray.futureProduction === 'No' && disgardTrf === true){
        qrfArray.isError = false;
    }
    else if( qrfArray.affectedMaterialLeft !== '' &&
      qrfArray.materialAffectedQty !== '' &&
      qrfArray.materialWorth !== '' &&
      qrfArray.futureProduction !== '' && frfArray.PDCA === "No"){
        qrfArray.isError = true;
    }
    else if (
      qrfArray.materialAffectedQty !== '' &&
      qrfArray.materialWorth !== '' &&
      qrfArray.affectedMaterialLeft !== '' &&
      //qrfArray.futureProduction !== '' &&
      (frfArray.failureDesc !== '' && frfArray.failureDesc !== null) &&
      //(frfArray.dateOfCompletion !== '' && proposedCorrectiveAction)
      (frfArray.rootCause !== '' && frfArray.rootCause !== null) &&
      (frfArray.correctiveAction !== '' && frfArray.correctiveAction !== null) &&
      //frfArray.PDCA !== '' &&
      frfArray.proposedCorrectiveAction !== '' &&
      ((qrfArray.futureProduction === 'Yes' && futureProductYes) || 
      (qrfArray.futureProduction === 'No' && disgardTrf)) && frfArray.PDCA === 'Yes'
    ) {

      qrfArray.isError = false;
    } else {
      qrfArray.isError = true;
    }
    if (!qrfArray.isError) {
      reviewFlag.isError = false;
    } else {
      reviewFlag.isError = true;
    }
    return [false, qrfArray.isError, reviewFlag.isError];
  }
  
  if( formDetails.meta.form === 'QrfInfo'){
    return oldQrFormValidate(formDetails)
  }
}
function attachmentupdate(element) {
  const attachment = element.map(data => (
    {
      fileName: data.fileName,
      format: data.fileName.split('.').pop(),
      submittedDate: moment(new Date()).format('MM/DD/YYYY')
    }))
  return attachment
}


function clearValues() {
  qrfArray = {
    affectedMaterial: '',
    materialAffectedQty: '',
    materialWorth: '',
    affectedMaterialLeft: '',
    futureProduction: null,
    isError: true
  };
  frfArray = {
    failureDesc: '',
    dateOfCompletion: '',
    correctiveAction: '',
    rootCause: '',
    PDCA: '',
    isUploaded: '',
    proposedCorrectiveAction: '',
  };

  return defaultState.errorClassName;
}
export default function qrf(state = defaultState, action) {
  switch (action.type) {
    case '@@redux-form/CHANGE':
      return { ...state, errorClassName: isValidated(action) };
    case '@@redux-form/INITIALIZE':
      return { ...state, errorClassName: validate(action) };
    case clearFormValueQRF.type:
      return { ...state, errorClassName: clearValues(), guideNo: false, guideYes: false, futureProductYes: false };


    case createServiceAction('qrfSubmit', 'success').type:
      return { ...state, qrfData: action.data };
    case createServiceAction('qrfUpdate', 'success').type:
      return { ...state, qrfData: action.data };

    case createServiceAction('trfDetailsForQrf', 'success').type:
      return {
        ...state,
        trfDetail: action.data,
        attachment: attachmentupdate(get(action.data, 'data.qrfAttachmentDetails')),
        attachmentNew: [],
        errorClassName: action.data.data.frfDetails.frfId ? [false, false, false] : [false, true, true]
      };
    case displaySubmitButtonQrf.type:
      return { ...state, shouldDisplaySubmit: action.payload };
    case displayClearButtonQrf.type:
      return { ...state, shouldDisplayClear: action.payload };
    case attachmentQrf.type:
      return {
        ...state,
        attachment: [...state.attachment, action.payload],
        attachmentNew: [...state.attachmentNew, action.payload]
      };
    case updateGuideYes.type:
      return {
        ...state,
        guideYes: action.payload,
      };
    case updateGuideNo.type:
      return {
        ...state,
        guideNo: action.payload,
      };
    case updateFutureProductYes.type:
      return {
        ...state,
        futureProductYes: action.payload,
      };
    case updateDisgardTrf.type:
      return {
        ...state,
        disgardTrf: action.payload,
      };
    case updateProposedCorrectiveAction.type:
      return {
        ...state,
        proposedCorrectiveAction: action.payload,
      };
    default:
      return state;
  }
}
